import { redirect } from 'react-router';
import { ROUTER_PATH } from '@constants/routerItems.constant';
import { resetPasswordService } from '../services/ResetPassword.service';
import type { TTokenVerificationResponse } from '../models/resetPassword.model';
import type { LoaderFunctionArgs } from 'react-router';

const tokenVerificationRouteLoader = async ({
  request
}: LoaderFunctionArgs<null>): Promise<TTokenVerificationResponse | Response> => {
  const token = new URL(request.url).searchParams.get('token');

  try {
    if (!token) {
      return redirect(ROUTER_PATH.login);
    }

    const response = await resetPasswordService.verifyToken({ token });

    return response.data;
  } catch {
    return redirect(ROUTER_PATH.login);
  }
};

export { tokenVerificationRouteLoader };
